import { Clock, FileText } from "lucide-react";
import { useState } from "react";
import legislationDataRaw from "~/legislacja-przegladinstalacji.json";

type FrequencyItem = { inspection: string; frequency: string; legalBasis: string };

const RESERVATION_TARGET_ID = "service-selector";

const items = (
  legislationDataRaw as { frequencySummary: { items: FrequencyItem[] } }
).frequencySummary.items;

export default function InspectionFrequencySelector() {
  const [selected, setSelected] = useState("");

  const item = items.find((i) => i.inspection === selected);
  const showReservationButton = Boolean(item);
  const labelClassName = "text-xs font-medium uppercase tracking-wide text-gray-400";
  const fieldClassName =
    "flex h-full min-h-[48px] items-center gap-2.5 rounded-lg border bg-white px-3 py-2.5 shadow-sm";
  const handleReservationClick = () => {
    const target = document.getElementById(RESERVATION_TARGET_ID);
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="w-full rounded-xl border border-slate-200 bg-slate-50 p-4 md:p-5">
      <div
        className={`grid gap-3 md:gap-4 ${
          showReservationButton
            ? "md:grid-cols-[minmax(0,24rem)_minmax(0,0.9fr)_minmax(0,1.35fr)_8.5rem] md:grid-rows-[auto_minmax(48px,auto)] md:items-stretch"
            : "md:max-w-[24rem]"
        }`}
      >
        <p className={labelClassName}>Sprawdź wymagany termin przeglądu</p>

        {item ? (
          <p className={labelClassName}>Częstotliwość</p>
        ) : null}

        {item ? (
          <p className={labelClassName}>Podstawa prawna</p>
        ) : null}

        {showReservationButton ? (
          <span className={`${labelClassName} invisible`}>Akcja</span>
        ) : null}

        <select
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="h-12 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-gray-800 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-1 focus:ring-sky-500 md:h-full"
        >
          <option value="">Wybierz rodzaj kontroli…</option>
          {items.map((i) => (
            <option key={i.inspection} value={i.inspection}>
              {i.inspection}
            </option>
          ))}
        </select>

        {item ? (
          <div className={`${fieldClassName} border-sky-100`}>
            <Clock className="mt-0.5 h-4 w-4 flex-shrink-0 text-sky-600" />
            <div className="min-w-0">
              <p className="text-sm font-semibold leading-snug text-sky-700">
                {item.frequency}
              </p>
            </div>
          </div>
        ) : null}

        {item ? (
          <div className={`${fieldClassName} border-slate-200`}>
            <FileText className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-400" />
            <div className="min-w-0">
              <p className="text-sm leading-snug text-gray-500">{item.legalBasis}</p>
            </div>
          </div>
        ) : null}

        {showReservationButton ? (
          <button
            type="button"
            onClick={handleReservationClick}
            className="inline-flex h-12 items-center justify-center rounded-lg bg-sky-700 px-4 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 md:h-full"
          >
            Rezerwuj
          </button>
        ) : null}
      </div>
    </div>
  );
}
